import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import CardApi from "../../apis/card.api";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import AppInput from "../../components/controls/AppInput";
import TopPageBack from "../../components/TopPageBack";
import { ROUTE_PATHS } from "../../constants/Router";
import useAuth from "../../hooks/useAuth";
import AppUtils from "../../utils";


const EditCardManage = () => {
    const navigate = useNavigate()
    const schema = yup.object().shape({
    });

    const location = useLocation()
    const state = location.state
    const cardInfo = state?.cardInfo

    const { control, handleSubmit, watch, reset, formState: { isDirty } } = useForm({
        resolver: yupResolver(schema),
    });
    const onSubmit = async (data) => {
        const dataRequest = {
            ...data,
            account_phone_no: data.account_phone_no.replaceAll('-',''),
            shop_idx: cardInfo?.shop_idx,
            payment_idx: cardInfo?.payment_idx,
            service_amount: cardInfo?.service_amount,
        }
        try {
            await CardApi.edit(dataRequest)
             navigate(ROUTE_PATHS.CardManage)
        } catch (error) {
        }
    };


    useEffect(() => {
        if(cardInfo) {
            reset({
                bank_name: cardInfo.bank_name ?? "",
                account_no: cardInfo.account_no ?? "",
                account_name: cardInfo.account_name ?? "",
                account_phone_no: AppUtils.convertToKoreaPhoneNumber(cardInfo?.account_phone_no) ?? "",
                account_jumin_biz_no: cardInfo.account_jumin_biz_no ?? "",
                apply_name: cardInfo.apply_name ?? "",
                apply_phone_no: cardInfo.apply_phone_no ?? "",
                account_relation: cardInfo.account_relation ?? "",
            })
        }

    }, [cardInfo]);
    return (
        <div>
            <TopPageBack>
                <b>계좌 변경 신청</b>
            </TopPageBack>
            <div className="mx-5">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="review-card2 py-4 mt-6 flex flex-col relative">
                        <div className="flex flex-col gap-2">
                            <div className="text-lg font-bold mb-1">자동이체 및 예금주 정보</div>
                            <div >
                                <AppInput
                                    control={control}
                                    name="bank_name"
                                    placeholder=""
                                    label="은행"
                                    className="mb-5"
                                    maxLength = {100}
                                />
                                <AppInput
                                    control={control}
                                    name="account_no"
                                    placeholder=""
                                    label="계좌번호"
                                    className="mb-5"
                                    type="number"
                                    maxLength = {50}
                                />
                                <AppInput
                                    control={control}
                                    name="account_name"
                                    placeholder=""
                                    label="예금주"
                                    className="mb-5"
                                    maxLength = {50}
                                />
                                <AppInput
                                    control={control}
                                    name="account_phone_no"
                                    placeholder=""
                                    label="예금주 휴대폰"
                                    className="mb-5"
                                    type="number"
                                    maximum={11}
                                    isKoreaPhoneNumber
                                    maxLength = {13}
                                />
                                <AppInput
                                    control={control}
                                    name="account_jumin_biz_no"
                                    placeholder=""
                                    label="예금주 생년월일"
                                    className="mb-5"
                                    maxLength = {13}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="review-card2 py-4 mt-6 flex flex-col relative">
                        <div className="flex flex-col gap-2">
                            <div className="text-lg font-bold mb-1">신청자 정보</div>
                            <div >
                                <AppInput
                                    control={control}
                                    name="apply_name"
                                    placeholder=""
                                    label="신청자"
                                    className="mb-5"
                                    maxLength = {50}
                                />
                                <AppInput
                                    control={control}
                                    name="apply_phone_no"
                                    placeholder=""
                                    label="신청자 휴대폰"
                                    className="mb-5"
                                    type="number"
                                    maxLength = {11}
                                />
                                <AppInput
                                    control={control}
                                    name="account_relation"
                                    placeholder=""
                                    label="예금주와의 관계"
                                    className="mb-5"
                                    maxLength = {50}
                                />
                            </div>
                        </div>
                    </div>


                    <SolidBlueBtn
                        disabled={!isDirty}
                        className="w-full mt-5 mb-3"
                        type="submit"
                    >
                        수정 완료
                    </SolidBlueBtn>
                </form>
            </div>


        </div>
    );
};

export default EditCardManage;
